// Client-side UX checks for profile photos. The authoritative check is server-side.
export const PROFILE_PHOTO_ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png']
export const PROFILE_PHOTO_ALLOWED_EXTENSIONS = ['jpg', 'jpeg', 'png']
export const PROFILE_PHOTO_ACCEPT = 'image/jpeg,image/png,.jpg,.jpeg,.png'
export const PROFILE_PHOTO_MAX_BYTES = 2 * 1024 * 1024
export const PROFILE_PHOTO_MESSAGES = {
  type: 'Use a JPG or PNG image.',
  size: 'Images must be 2 MB or smaller.'
}
export const PROFILE_PHOTO_RULES = 'profile_photo_type|profile_photo_size'

export function isAllowedProfilePhotoType (file: File): boolean {
  if (!file) return false
  const name = typeof file.name === 'string' ? file.name : ''
  const dot = name.lastIndexOf('.')
  const extension = dot >= 0 ? name.slice(dot + 1).toLowerCase() : ''
  return PROFILE_PHOTO_ALLOWED_MIME_TYPES.includes(file.type) &&
    PROFILE_PHOTO_ALLOWED_EXTENSIONS.includes(extension)
}

export function isAllowedProfilePhotoSize (file: File): boolean {
  return !!file && file.size <= PROFILE_PHOTO_MAX_BYTES
}

export function validateProfilePhotoFile (file: File | null | undefined): string | null {
  if (!file) return null
  if (!isAllowedProfilePhotoType(file)) return PROFILE_PHOTO_MESSAGES.type
  if (!isAllowedProfilePhotoSize(file)) return PROFILE_PHOTO_MESSAGES.size
  return null
}

export function extractProfilePhotoServerError (error: any): string | null {
  if (!error || error.status !== 422) return null
  const messages = error.data?.errors?.profile_photo
  if (!messages) return null
  const first = Array.isArray(messages) ? messages[0] : messages
  return typeof first === 'string' && first ? first : null
}
